@if ((useLazyLoad || isLoaded) && !isIncomplete) {
  <sd-footnote
    [textConfig]="textConfig"
    [footNotes]="footnote"
    [isLoading]="!isLoaded"
    [brand]="brandCorner"
  />
}
